/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function EmploymentInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <b>Current Opportunities at Elections Nova Scotia</b>
          <br/ >
          Elections Nova Scotia (ENS) is a non-partisan and independent agency responsible for conducting provincial elections. It takes a lot of people and effort to make sure the electoral process runs smoothly in our province. ENS needs dedicated staff at our headquarters to plan and prepare for elections as well as election workers in the field to facilitate voting. 
          <br/ ><br/ >
          Any positions ENS is recruiting for will be posted here. 
          <br/ ><br/ >
          Please ensure your read postings thoroughly and follow the application instructions. Incomplete applications will not be considered for an interview. 


          {/* <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Employment"
              description={
                <>
                <br />
                  <i><b><h3>Manager, Election Planning and Services</h3></b></i>
                  <br />
                  <b>Competition #</b>: 49312<br />
                  <b>Department</b>: Elections Nova Scotia<br />
                  <b>Location</b>: BURNSIDE<br />
                  <b>Type of Employment</b>: Permanent<br />
                  <b>Union Status</b>: Exclusion - Non Union - NSPG<br />
                  <b>Closing Date</b>: 29-Jul-26  (Applications are accepted until 11:59 PM Atlantic Time)
                  <br /><br />
                  The Manager of Election Planning and Services serves as a pivotal member of the leadership team, responsible for overseeing a comprehensive portfolio of election readiness initiatives. This role directs a dedicated team in the implementation and execution of critical projects, ensuring Elections Nova Scotia remains prepared to deliver seamless by-elections and provincial general elections. 
                  <br /><br />
                  Click <a href="https://jobs.novascotia.ca/job/BURNSIDE-Manager%2C-Election-Planning-and-Services-NS-B3B-1T5/604343917/"><i><b><u>here</u></b></i></a> for the full job posting and application details 
                  <br />                 
                </>
              }
            />
          </Grid> */}
          
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Employment"
              description={
                <>
                <br />
                  <i><b><h3>Returning Officer</h3></b></i>
                  <br />
                  Elections Nova Scotia is currently recruiting qualified candidates for the challenging and rewarding role of returning officer in the following electoral districts: 
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Cole Harbour Dartmouth</li>
                    <li>Dartmouth North</li>
                    <li>Lunenburg West</li>
                  </ul>
                  <br />
                  A returning officer administers the election in the electoral district to which they are appointed. This is an excellent opportunity for professionals seeking part-time flexible work. Successful candidates must be impartial and declare they are non-partisan. Please see the following job description for more details: <a href="/files/Employment/Returning Officer Job Description.pdf">PDF</a> 
                  <br /><br />
                  If you are interested in finding out more about the role of a returning officer and current vacancies, please contact Elections Nova Scotia at 1-800-565-1504 or <a href="mailto:elections@novascotia.ca"><i><b><u>elections@novascotia.ca</u></b></i></a>.
                  <br /><br />
                  If you would like to apply now, please click the following link: <a href="https://enstools.electionsnovascotia.ca/jobapplication/">Application for Returning Officer</a>
                  <br />                 
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default EmploymentInformation;
